import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

export default function SavedFilterManager({
  onUpdateFilter,
  onCreateNewFilter,
  existingFilterNames = '',
  visibility="public",
  setVisibility,
}) {
  const [activeFilterName, setActiveFilterName] = useState('');
  const [filterNameInput, setFilterNameInput] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [saveDialogMode, setSaveDialogMode] = useState('create'); // 'create' | 'update'
  //const [visibility, setVisibility] = useState('Public');
  const wrapperRef = useRef(null);
    
  useEffect(()=>{
    setActiveFilterName(existingFilterNames);
  },[existingFilterNames]);
  const handleOpenDialog = () => {
    setFilterNameInput(activeFilterName);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
  };
  const handleInputChange = (e) => {
    const name = e.target.value;
    //const exists = existingFilterNames.includes(name);
    setFilterNameInput(name);
    //onFilternameUpdate(name);
    //setFilterNameInput(exists ? `${name} (Copy)` : name);
  };

  const handleUpdate = () => {
    onUpdateFilter(filterNameInput, visibility);
    setActiveFilterName(filterNameInput);
    handleCloseDialog();
  };

  const handleCreate = () => {
    onCreateNewFilter(filterNameInput,visibility);
    setActiveFilterName(filterNameInput);
    setSaveDialogMode('update');
    handleCloseDialog();
  };

  return (
    <div>
      <div className="flex items-center gap-2">
        <button onClick={handleOpenDialog} className="text-sm text-blue-600 underline">
         {activeFilterName !== '' ? "Update Filter" : "Save Filter"}
        </button>
      </div>

      {showDialog && (
        <motion.div ref={wrapperRef} className="absolute w-72 bg-white border rounded shadow z-30">
          <div className="p-2">
            <h4 className="text-sm mb-2 font-semibold">
              {activeFilterName !== '' ? 'Update Filter' : 'Save Filter'}
            </h4>
            <input
              type="text"
              placeholder="Filter Name"
              value={filterNameInput}
              onChange={handleInputChange}
              className="border px-2 py-1 rounded mb-2 w-full"
            />
            <div className="mb-2 flex gap-5 items-center">
              <label className="flex items-center">
                <input
                  type="radio"
                  value="Public"
                  checked={visibility === 'public'}
                  onChange={(e) => setVisibility?.((e.target.value).toLocaleLowerCase())}
                  className="mr-2"
                />
                Public
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  value="Private"
                  checked={visibility === 'private'}
                  onChange={(e) => setVisibility?.((e.target.value).toLocaleLowerCase())}
                  className="mr-2"
                />
                Private
              </label>
            </div>

            <div className="space-y-2">
  <div className="flex gap-2">
    {activeFilterName !== '' && (
      <button className="flex-1 bg-blue-500 text-white items-center justify-center rounded px-4 py-1 text-sm" onClick={handleUpdate}>
        Update</button>
    )}
    <button
      className="flex-1 bg-blue-500 text-white items-center justify-center rounded px-4 py-1 text-sm"
      onClick={handleCreate}
    >
      {activeFilterName !== '' ? 'Create New' : 'Save Filter'}
    </button>
  </div>

  <button
    className="w-full bg-gray-300 text-gray-800 rounded px-4 py-1 text-sm"
    onClick={handleCloseDialog}
  >
    Cancel
  </button>
</div>

          </div>
        </motion.div>
      )}
    </div>
  );
}
